// returns the current page slug (e.g., "inventory", "sales-orders")
export function getPageSlug(): string {
    const pathname = window.location.pathname;
    const segments = pathname.split("/").filter(Boolean); // remove empty parts
    return segments[0] || ""; // return first part of the path or empty string
  }
  
  export default getPageSlug;
  